export const setTextareaAutosize = $textarea => {
  $textarea.css('height', $textarea[0].scrollHeight + 'px')

  $textarea.on('input', () => {
    $textarea.css('height', 'auto')
    $textarea.css('height', $textarea[0].scrollHeight + 'px')
  })
}
